// Routes of this item and the deep links other items build to its panels.
// Panel state lives in the URL (`?panel=`) so every panel is deep-linkable
// and the browser back button closes it. The contracts other items already
// use (payables, installments, ledger) are kept as published:
//
//   /accounts/vouchers?panel=payment-voucher&supplier_id=&purchase_id=&amount_minor=   pre-filled payment
//   /accounts/vouchers?panel=payment-voucher&voucher_id=                               payment, read-only
//   /accounts/vouchers?panel=receipt-voucher&voucher_id=                               receipt, read-only
//   /accounts/vouchers?panel=receipt-voucher&customer_id=&customer_name=[&amount_minor=&against=&invoice_id=&invoice_no=]  new receipt
//
// The same `panel=` params work on /accounts/expenses, /accounts/cash and
// /accounts/cash/:tillId (the panel opens over whichever host is current).

export const VOUCHERS_PATH = '/accounts/vouchers';
export const EXPENSES_PATH = '/accounts/expenses';
export const CASH_PATH = '/accounts/cash';

export const PANEL_RECEIPT = 'receipt-voucher';
export const PANEL_PAYMENT = 'payment-voucher';
export const PANEL_OPEN_TILL = 'open-till';
export const PANEL_CLOSE_TILL = 'close-till';

export type PanelKey = typeof PANEL_RECEIPT | typeof PANEL_PAYMENT | typeof PANEL_OPEN_TILL | typeof PANEL_CLOSE_TILL;

export const cashDayPath = (tillId: string) => `${CASH_PATH}/${encodeURIComponent(tillId)}`;

function qs(params: Record<string, string | number | null | undefined>): string {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v != null && v !== '') s.set(k, String(v));
  const out = s.toString();
  return out ? `?${out}` : '';
}

export interface ReceiptPrefill {
  customer_id: string;
  customer_name: string;
  amount_minor?: number;
  against?: 'full_balance' | 'on_account' | 'invoice';
  invoice_id?: string;
  invoice_no?: string;
  till_id?: string;
}

/** New receipt voucher pre-filled for a customer (statement, receivables, invoice hosts). */
export function receiptVoucherHref(p: ReceiptPrefill, base = VOUCHERS_PATH): string {
  return `${base}${qs({ panel: PANEL_RECEIPT, ...p })}`;
}

export function receiptVoucherViewHref(voucherId: string, base = VOUCHERS_PATH): string {
  return `${base}${qs({ panel: PANEL_RECEIPT, voucher_id: voucherId })}`;
}

export interface PaymentPrefill {
  supplier_id?: string;
  purchase_id?: string;
  amount_minor?: number;
  /** Pre-select «الدفع من» = this till (cash-day «سند صرف»). */
  till_id?: string;
}

export function paymentVoucherHref(p: PaymentPrefill = {}, base = VOUCHERS_PATH): string {
  return `${base}${qs({ panel: PANEL_PAYMENT, ...p })}`;
}

export function paymentVoucherViewHref(voucherId: string, base = VOUCHERS_PATH): string {
  return `${base}${qs({ panel: PANEL_PAYMENT, voucher_id: voucherId })}`;
}

/** The payroll run behind an automatic salaries voucher (team module, owner). */
export function payrollHref(period: string): string {
  return `/team/payroll${qs({ period })}`;
}

/** Owner reopens a closed month on the period-close page (HANDOFF §5.8). */
export function reopenHref(month: string): string {
  return `/accounts/close${qs({ reopen: month })}`;
}

export function settingsBranchesHref(): string {
  return '/settings/branches';
}
